
import Vue, { PropType } from 'vue'
import { Judge } from '@/model/Judge'

export default Vue.extend({
  name: 'Judge',
  props: {
    judge: {
      type: Object as PropType<Judge>,
    },
  },
  data: () => ({}),
})
